<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/settings']">Zur Konfiguration</a>
    </li>
  </ul>
</nav>

<main>
  <h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Konfiguration  <cds-icon shape="two-way-arrows"></cds-icon>  Material</h2>

  <div class="clr-row">
    <div class="clr-col-12">
      <div class="card">
        <div class="card-header">
          Material
          <br />
          <a *ngIf="editMaterial === 1" class="btn btn-primary btn-sm" (click)="editMaterial = 0; updatingMaterial = false; editMaterialId = 0">Bearbeitung beenden</a>
          <a *ngIf="editMaterial === 0" class="btn btn-primary btn-sm" (click)="editMaterial = 1">Material bearbeiten</a>
        </div>
        <div class="card-block">
          <div class="card-text">

            <form clrForm [formGroup]="materialForm">
              <clr-datagrid *ngIf="editMaterial < 2" [clrDgLoading]="loading" id="materialDataGrid">
                <clr-dg-column [clrDgField]="'material'" [clrDgSortOrder]="descSort">Material</clr-dg-column>
                <clr-dg-column>Werkstoffbezeichnung</clr-dg-column>
                <clr-dg-column>Werkstoffnummer</clr-dg-column>
                <clr-dg-column>Wärmebehandlungszustand</clr-dg-column>
                <clr-dg-column>Beschreibung</clr-dg-column>
                <clr-dg-column>Alternative</clr-dg-column>
                <clr-dg-column>Datenblatt</clr-dg-column>
                <clr-dg-column *ngIf="editMaterial === 1">Aktion</clr-dg-column>

                <clr-dg-placeholder>
                  <div class="datagrid-placeholder">
                    <cds-icon shape="info-circle" aria-hidden="true" style="margin-right:8px"></cds-icon>
                    <span>Keine Materialien gefunden</span>
                  </div>
                </clr-dg-placeholder>

                <clr-dg-row *clrDgItems="let item of materials">
                  <clr-dg-cell>{{ item.material }}</clr-dg-cell>
                  <clr-dg-cell>{{ item.werkstoffbezeichnung }}</clr-dg-cell>
                  <clr-dg-cell>{{ item.werkstoffnummer }}</clr-dg-cell>
                  <clr-dg-cell>{{ item.waermebehandlungszustand }}</clr-dg-cell>
                  <clr-dg-cell>{{ item.description }}</clr-dg-cell>
                  <clr-dg-cell>{{ item.alternative }}</clr-dg-cell>
                  <clr-dg-cell>
                    <ng-container *ngIf="getDatenblattFiles(item).length > 0; else noDatenblatt">
                      <div *ngFor="let file of getDatenblattFiles(item)">
                        <clr-tooltip>
                          <button
                            class="btn btn-sm btn-link"
                            clrTooltipTrigger
                            (click)="openPdfFile(file, item)"
                            aria-label="Datenblatt anzeigen"
                          >
                            <cds-icon shape="pdf-file" size="20" aria-hidden="true"></cds-icon>{{ file.fileName }}
                          </button>
                          <clr-tooltip-content [clrPosition]="'top-right'" [clrSize]="'sm'">
                            {{ file.fileName || file.id }}
                          </clr-tooltip-content>
                        </clr-tooltip>
                      </div>
                    </ng-container>
                    <ng-template #noDatenblatt></ng-template>
                  </clr-dg-cell>
                  <clr-dg-cell *ngIf="editMaterial === 1" class="btn-group btn-primary btn-icon">
                    <button *ngIf="!updatingMaterial" class="btn btn-sm" (click)="updateMaterialMode(item.material_id)" aria-label="Material bearbeiten" title="Ändern">
                      <cds-icon shape="pencil" aria-hidden="true"></cds-icon>
                      <span class="clr-icon-title">Ändern</span>
                    </button>
                    <button class="btn btn-warning btn-sm" (click)="deleteMaterial(item.material_id, item.material)" aria-label="Material löschen" title="Löschen">
                      <cds-icon shape="times" aria-hidden="true"></cds-icon>
                      <span class="clr-icon-title">Löschen</span>
                    </button>
                  </clr-dg-cell>
                </clr-dg-row>

                <clr-dg-row *ngIf="(editMaterial === 1) && !updatingMaterial">
                  <clr-dg-cell><input type="text" formControlName="material" placeholder="Material" class="clr-input" required></clr-dg-cell>
                  <clr-dg-cell><input type="text" formControlName="werkstoffbezeichnung" placeholder="Werkstoffbezeichnung" class="clr-input"></clr-dg-cell>
                  <clr-dg-cell><input type="text" formControlName="werkstoffnummer" placeholder="Werkstoffnummer" class="clr-input"></clr-dg-cell>
                  <clr-dg-cell><input type="text" formControlName="waermebehandlungszustand" placeholder="Wärmebehandlungszustand" class="clr-input"></clr-dg-cell>
                  <clr-dg-cell><input type="text" formControlName="description" placeholder="Beschreibung" class="clr-input"></clr-dg-cell>
                  <clr-dg-cell><input type="number" formControlName="alternative" placeholder="Alternative" class="clr-input"></clr-dg-cell>
                  <clr-dg-cell><input type="text" formControlName="datenblatt" placeholder="Datenblatt" class="clr-input"></clr-dg-cell>
                  <clr-dg-cell class="btn-group btn-primary btn-icon">
                    <button class="btn btn-sm" (click)="addMaterial()" [disabled]="materialForm.invalid" aria-label="Material speichern" title="Speichern">
                      <cds-icon shape="floppy" aria-hidden="true"></cds-icon>
                      <span class="clr-icon-title">Speichern</span>
                    </button>
                  </clr-dg-cell>
                </clr-dg-row>

                <clr-dg-footer>
                  <clr-dg-pagination #pagination [clrDgPageSize]="50">
                    <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Material pro Seite</clr-dg-page-size>
                    {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
                    von {{materials.length}} Material(ien)
                  </clr-dg-pagination>
                </clr-dg-footer>
              </clr-datagrid>

              <app-edit-material *ngIf="editMaterial === 2" [editMaterialId]="editMaterialId" (updatedMaterial)="onUpdateMaterial($event)"></app-edit-material>

              <br />
              <a *ngIf="editMaterial === 1" class="btn btn-primary btn-sm" (click)="editMaterial = 0; updatingMaterial = false; editMaterialId = 0">Bearbeitung beenden</a>
              <a *ngIf="editMaterial === 0" class="btn btn-primary btn-sm" (click)="editMaterial = 1">Material bearbeiten</a>
            </form>

          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<clr-modal *ngIf="showPDF" id="pdfViewer" [(clrModalOpen)]="showPDF" [clrModalStaticBackdrop]="false" [clrModalSize]="modalSize">
  <h3 class="modal-title">{{ modalContent }}</h3>
  <div class="modal-body">
    <ngx-extended-pdf-viewer [src]="modalUrl" useBrowserLocale="true" height="85vh" [textLayer]="true"></ngx-extended-pdf-viewer>
  </div>
</clr-modal>
